<span
  *ngIf="label; else calendar"
  class="p-float-label">
  <ng-container *ngTemplateOutlet="calendar"></ng-container>
  <label [for]="inputId">{{ label }}</label>
</span>

<ng-template #calendar>
  <div class="p-inputgroup">
    <span class="p-inputgroup-addon"><i class="pi pi-calendar"></i></span>
    <p-calendar
      #rangepicker
      (ngModelChange)="changeDate($event)"
      (onShow)="show.emit($event)"
      (onClose)="close.emit($event)"
      [(ngModel)]="_value"
      [dateFormat]="dateFormat"
      [firstDayOfWeek]="1"
      [inputId]="inputId"
      [placeholder]="placeholder"
      [selectOtherMonths]="true"
      [showButtonBar]="showButtonBar"
      [appendTo]="appendTo"
      [showClear]="showClear"
      selectionMode="range"
      styleClass="w-full">
      <ng-template pTemplate="header">
        <div class="flex flex-wrap">
          <div class="w-6 p-1">
            <button
              *ngIf="isShowDay"
              (click)="setPeriodDates('day')"
              class="p-button-sm p-button-success p-button-outlined w-full"
              label="сегодня"
              pButton></button>
          </div>
          <div class="w-6 p-1">
            <button
              *ngIf="isShowDay"
              (click)="setPeriodDates('day', true)"
              class="p-button-sm p-button-success p-button-outlined w-full"
              label="вчера"
              pButton></button>
          </div>
          <div class="w-6 p-1">
            <button
              (click)="setPeriodDates('week')"
              class="p-button-sm p-button-success p-button-outlined w-full"
              label="текущая неделя"
              pButton></button>
          </div>
          <div class="w-6 p-1">
            <button
              (click)="setPeriodDates('month')"
              class="p-button-sm p-button-success p-button-outlined w-full"
              label="текущий месяц"
              pButton></button>
          </div>
          <div class="w-6 p-1">
            <button
              (click)="setPeriodDates('month', true)"
              class="p-button-sm p-button-success p-button-outlined w-full"
              label="прошлый месяц"
              pButton></button>
          </div>
          <div class="w-6 p-1">
            <button
              (click)="setPeriodDates('year')"
              class="p-button-sm p-button-success p-button-outlined w-full"
              label="текущий год"
              pButton></button>
          </div>
        </div>
      </ng-template>
    </p-calendar>
  </div>
</ng-template>
